import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiCallStatusService {
  private activeRequestsCount = 0;
  private isApiInProgress = new BehaviorSubject<boolean>(false);
  isApiInProgress$= this.isApiInProgress.asObservable();
  constructor() { }

  /**
   * Emits true immediately and stays true until all tracked API calls have
   * completed for a stable period. The stable period also captures dependent
   * requests that legacy screens schedule shortly after a parent request.
   */
  public trackInitialLoad(stableIdleMs = 1500): Observable<boolean> {
    return new Observable<boolean>((subscriber) => {
      let hasSeenApiActivity = this.activeRequestsCount > 0;
      let idleTimer: ReturnType<typeof setTimeout> | undefined;

      subscriber.next(true);

      const clearIdleTimer = () => {
        if (idleTimer) {
          clearTimeout(idleTimer);
          idleTimer = undefined;
        }
      };

      const statusSubscription = this.isApiInProgress$.subscribe(
        (isApiInProgress) => {
          if (isApiInProgress) {
            hasSeenApiActivity = true;
            clearIdleTimer();
            return;
          }

          if (!hasSeenApiActivity) {
            return;
          }

          clearIdleTimer();
          idleTimer = setTimeout(() => {
            subscriber.next(false);
            subscriber.complete();
          }, stableIdleMs);
        }
      );

      return () => {
        clearIdleTimer();
        statusSubscription.unsubscribe();
      };
    });
  }

    public incrementRequestCount() {
      this.activeRequestsCount++;
      this.isApiInProgress.next(true);
    }
  
    public decrementRequestCount() {
      this.activeRequestsCount--;
      if (this.activeRequestsCount <= 0) {
        this.isApiInProgress.next(false);
      }
    }
}
